/* unplugin-vue-components disabled */import script from "./AccountBalanceRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountBalanceRecord.vue?vue&type=script&setup=true&lang=js"

import "./AccountBalanceRecord.vue?vue&type=style&index=0&id=5108b6aa&lang=scss"

const __exports__ = script;

export default __exports__